import './platform/dashboard';



// WEBPACK FOOTER //
// ./src/javascripts/platform.js